import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useGlifeOpenExternalLink} from './useGlifeOpenExternalLink';
import {getActiveBalance} from '../selectors/payments-selectors';
import {AppState, useAppSelector} from '../RootReducer';
import {showCashier} from '../payments/DepositActions';
import {CashierSection} from '../payments/PaymentsReducer';
import {BrandButton} from '../ui/buttons/buttons';
import {BrandLogo} from '../ui/navigation/NavMenu';
import {fetchAndParseContent} from '../contenful/ContentfulActions';
import {ContentModelName} from '../contenful/types';
import {getStatusForContent} from '../selectors/content-selectors';
import {ContentStatus} from '../contenful/ContentfulReducer';
import {getContainer} from '../ioc/IOCSetup';
import './GlifeLandingPage.scss';
import {t} from "../i18n";
import DynamicContentView from "../landingpage/pagesection/DynamicContentView";
import {getLoggedIn} from "../selectors/user-selectors";
import {Link} from "react-router-dom";


export const GlifeLandingPage: React.FC = () => {
  const dispatch = useDispatch();
  const balance = useSelector((state: AppState) => getActiveBalance(state)?.balance?.amount || 0);
  const { openExternalLink } = useGlifeOpenExternalLink();
  const global = useAppSelector((s) => s.contentful.global);
  const bannerStatus = useSelector((app: AppState) => getStatusForContent(app, ContentModelName.APP_LANDING_PAGE));
  const landingPage = useAppSelector((app: AppState) => app.contentful.appLandingPage);
  const loggedIn = useAppSelector((s) => getLoggedIn(s));
  useEffect(() => {
    console.log('Fetching banner content...');
    dispatch(fetchAndParseContent(ContentModelName.APP_LANDING_PAGE, getContainer().getSettingsService().getActiveLocale().code, false) as any);
  }, [dispatch, landingPage]);

  const handleWithdraw = () => {
    dispatch(showCashier(true, CashierSection.WITHDRAW) as any);
  };

  const handleDeposit = () => {
    dispatch(showCashier(true, CashierSection.DEPOSIT) as any);
  };

  const handleGameClick = (path: string) => {
    openExternalLink(path);
  };

  let loading = bannerStatus === ContentStatus.IN_PROGRESS && !landingPage?.topDynamicContent;
  return (
    <div className="glife-page-container">
      <div className="glife-page-wrapper">
        <header className="glife-main-header glife-mobile">
          {global && <BrandLogo global={global} />}
        </header>

        <div className="glife-content-wrapper">
          {loading && (
            <div className="carousel-loader"></div>
          )}
          {!loading && (
              <DynamicContentView dynamicContent={landingPage?.topDynamicContent} loggedIn={loggedIn}/>
          )}

          <div className="glife-balance-section">
            <div className="glife-balance-header">{t('glifeLandingpage.glife-balance')}</div>
            <div className="glife-balance-amount">
              <span className="glife-currency">P</span>
              {balance.toLocaleString()}
            </div>
            <div className="glife-button-group">
              <BrandButton className="btn btn-secondary small withdraw" onClick={handleWithdraw}>
                {t('glifeLandingpage.withdrawal')}
              </BrandButton>
              <BrandButton className="btn btn-cta small deposit" onClick={handleDeposit}>
                {t('glifeLandingpage.deposit-button-top-up')}
              </BrandButton>
            </div>
          </div>

          <div className="glife-games-section">
            <div className="glife-section-header">
              <h2>{t('glifeLandingpage.games')}</h2>
              <Link href="#" className="glife-see-all" to={"/casino"}>{t('glifeLandingpage.see-all')}</Link>
            </div>
            <div className="glife-game-grid">
              {landingPage?.links?.map((link) => (
                <Link key={link._id} className="glife-game-card" to={link.linkUrl ?? "/"}  style={{backgroundImage : `url(${link.linkImage?.fields?.file?.url})`}}>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 